
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField, Typography } from "@mui/material"
import { descargarImagen } from "../../../helpers/descargarArchivo";
import { useQueryClient } from "@tanstack/react-query";
import { editarValoresDetalles } from "../../../services";


const baseUrl = process.env.REACT_APP_API_URL;




export const DetallesImagenItem = ({ data }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const [detalles, setDetalles] = useState(data?.detalles);


    const handleDescargar = (img) => {
        const url = `${ baseUrl }/uploads/items/${ img }`;
        fetch(url).then( resp => descargarImagen(resp) );
    }



    const handleGuardarDetalle = async(e) =>{
        // setDetalles( target.value );
        // if( debounceRef.current )
        //     clearTimeout( debounceRef.current );

        // debounceRef.current = setTimeout( async() => {
        //     await editarValoresDetalles({ id, detalles });
        //     queryClient.invalidateQueries({ queryKey: ['itemxid'] });
        // }, 600);
        if(e.key === "Enter") {
            const { value } = e.target;
            e.preventDefault(); 
            await editarValoresDetalles({ id, detalles: value });
            queryClient.invalidateQueries({ queryKey: ['itemxid'] });
        }
    }
    



    return (

        <>
        {(data) &&
        <Grid container textAlign='center'>

            <Grid item xs={12} my={4}>
                <Typography variant="h4" sx={{ my:2, fontSize:22 }}>Detalles</Typography>
                <TextField
                    id="outlined-multiline-flexible"
                    label="Poner Detalles..."
                    multiline
                    fullWidth
                    value={ detalles }
                    onChange={(e) => setDetalles(e.target.value)}
                    onKeyDown={ handleGuardarDetalle }
                />
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h4" sx={{my:2, fontSize:22}}>Imagen o Diseño</Typography>
                {( data?.imgCliente )
                ?   <img src={`${ baseUrl }/uploads/items/${ data.imgCliente }`} style={{width:600}} />
                :   <img src={`${ baseUrl }/uploads/categorias/no-img.jpg`} alt="Error en imagen" style={{width:500}} />
                }
            </Grid>

            <Grid item xs={12} my={3} >
                <Button variant="contained" color="secondary" 
                    disabled={ !data.imgCliente }
                    onClick={() => handleDescargar(data.imgCliente)}
                >
                    Descargar Archivo
                </Button>
            </Grid>

        </Grid>
        }
        </>

    )
}
